import React, { useState } from 'react'
import CancelIcon from '@material-ui/icons/Cancel'
import Checkbox from '@material-ui/core/Checkbox'

import pushImage from '../../images/push_image.svg'
import { createEndpoint } from 'apis/me'
interface Props {
  close?: Function
  callback?: Function
}
export default function NotificationPermissionDialog(props: Props) {
  const [dontShowAgain, setDontShowAgain] = useState(false)

  function urlBase64ToUint8Array(base64String: string) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')

    var rawData = window.atob(base64)
    var outputArray = new Uint8Array(rawData.length)

    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  }

  const enablePushNotification = () => {
    if (props.close) {
      props.close()
    }

    if ('Notification' in window && navigator.serviceWorker) {
      // 通知が許可されていたら早期リターン
      const permission = Notification.permission
      if (permission === 'denied' || permission === 'granted') {
        return
      }
      // 通知の許可を求める
      Notification.requestPermission().then(() => {
        if (Notification.permission === 'granted') {
          if (props.callback) {
            props.callback()
          }
          const swUrl = `${process.env.PUBLIC_URL}/sw.js`

          navigator.serviceWorker.register(swUrl).then((registration) => {
            // Register subscription
            registration.pushManager
              .subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(
                  process.env.REACT_APP_APPLICATION_SERVER_PUBLIC_KEY!
                )
              })
              .then((subscription) => {
                return createEndpoint(subscription)
              })
              .catch((err) => {
                console.error(err)
              })
          })
        }
      })
    }
  }
  const handleClose = (e: any) => {
    if (props.close) {
      props.close()
    }
  }
  return (
    <section className="modal -push" id="modal-door">
      <div className="modal-header">
        <div id="alert-dialog-title" className="title">
          プッシュ通知を受け取りましょう！
        </div>
        <div className="close modal-close">
          <CancelIcon onClick={handleClose} />
        </div>
      </div>
      <div className="modal-contents -push">
        <div className="modal-contents__inner">
          <p>
            オーナーの新規投稿、あなたへのコメントやメンションの通知を受け取れるようになります。
          </p>
          <img src={pushImage} alt="pushimage" />
        </div>
        <div className="modal-contents__footer">
          <div className="pushSetting">
            <div className="pushSetting__left">
              <Checkbox
                color="primary"
                onChange={(e) => {
                  setDontShowAgain(e.target.checked)
                }}
              />
              次回から表示しない
            </div>
            <div className="pushSetting__right">
              <div
                className="btn-later"
                onClick={(e) => {
                  if (dontShowAgain) {
                    localStorage.setItem('dont_show_again', 'true')
                  }
                  handleClose(e)
                }}
              >
                あとで
              </div>
              <div className="btn-push" onClick={enablePushNotification}>
                プッシュ通知を許可する
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
